var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 34,
    viewBox: "0 0 15 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.21 31.977L11.665 17 2.209 2.023",
    stroke: "currentColor",
    strokeWidth: 4
  })));
}
export default __webpack_public_path__ + "media/icons/chevron-right-ee1b6b97.svg";
export { SvgChevronRight as ReactComponent };